// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"ecf82fa12b54e9ff1578","574":"e0065c11bcc5c747d4ba","581":"51b30ea3bd8281cfc757","926":"b6bfa769deab59c9a366"}[chunkId] + ".css";
};